import React, { FunctionComponent } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import BriefUnsubscribePage from '../../pages/brief/unsubscribe/BriefUnsubscribePage';
import StripeCheckoutCallbackPage from '../../pages/treasury/StripeCheckoutCallbackPage';
import UsersPage from '../../pages/users/UsersPage';
import DashboardApp from '../App/DashboardApp';
import ProtectedRoute from '../protected-route/ProtectedRoute';
import SingleColumnLayout from '../single-column-layout/SingleColumnLayout';

// Legacy deactivate-account entry point (emails, support links); the flow
// now lives in a dialog on the settings overview page.
const DeactivateAccountRedirect: FunctionComponent = () => (
  <Redirect to={'/dashboard/settings/overview?deactivate'} />
);

const AppRoutes: FunctionComponent = () => {
  return (
    <Switch>
      <Route path={'/auth'} component={SingleColumnLayout} />
      <Route path={'/email'} component={SingleColumnLayout} />
      <Route path={'/login'} component={SingleColumnLayout} />
      <Route path={'/popup'} component={SingleColumnLayout} />
      <Route exact path={'/brief/unsubscribe'} component={BriefUnsubscribePage} />
      <Route exact path={'/treasury/callback/'} component={StripeCheckoutCallbackPage} />
      <Route exact path="/users/" component={UsersPage} />
      <Route path="/users/signin" component={UsersPage} />
      <Route path="/users/signup" component={UsersPage} />
      <Route path={'/users'} component={SingleColumnLayout} />
      <Route path={'/verify-email'} component={SingleColumnLayout} />
      <ProtectedRoute exact path={`/cancel`} component={DeactivateAccountRedirect} />
      <ProtectedRoute path={'/dashboard'} component={DashboardApp} />
      <Route render={() => <Redirect to={'/users/signin'} />} />
    </Switch>
  );
};

export default AppRoutes;
